import React from "react";
import CourbesStatChart from "./CourbesStatChart.jsx";

/**
 * Troisième graphique de Besoin en eau : irrigation CUMULÉE, en ÉCART avec 2020
 * (ou la référence en TRACC), via CourbesStatChart.
 *
 * On cumule d'abord chaque statistique jour après jour, puis on fait la
 * différence des cumuls : pour q75, q90 et max, la valeur de 2035 est
 * q75_cumulé_2035 - q75_cumulé_2020 (idem q90 / max), celle de 2050
 * q75_cumulé_2050 - q75_cumulé_2020.
 *
 * Pas de tableau, pas de 2020 dans le sélecteur d'années (c'est la base de
 * l'écart) et pas de Moyen dans celui des statistiques.
 * Coché à l'ouverture : Quantile 90 seulement.
 *
 * (Le nom du fichier est resté IrrigationJournalierChart : c'est lui qui est
 * importé par BesoinEnEau.jsx.)
 */
export default function IrrigationJournalierChart({ data, xMax }) {
  return (
    <CourbesStatChart
      data={data}
      prefixe="irr"
      cleDate="date_affichage"
      unite="mm"
      nomAxe="Écart d'irrigation cumulée avec 2020 (mm)"
      statsParDefaut={["q90"]}
      statsDisponibles={["q75", "q90", "max"]}
      cumul
      ecartAvecBase
      afficherTableau={false}
      xMax={xMax}
    />
  );
}
